// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1OIHk","paramInput":"JobSimulator_paramInput__2WRky","input":"JobSimulator_input__NYMtK"};